import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { ModalControl } from '@entrata/portals-common/lib/components'
import { ChargeDetailsModal } from 'portal-modules/ledger/components/modals'
import { StyledLinksSpan } from './atoms'

const DetailsModal = ({
  formatedType,
  balance,
  arCodeId,
  isCharge,
  isPayment,
  createdByName,
  tax_exclusive,
  ...rest
}) =>
  isCharge ? (
    <ModalControl>
      {({ onClick, ref, ...modalProps }) => (
        <Fragment>
          <StyledLinksSpan onClick={onClick} ref={ref}>
            {formatedType}
          </StyledLinksSpan>
          <ChargeDetailsModal
            {...modalProps}
            chargeTitle={formatedType}
            balance={balance}
            arCodeId={arCodeId}
            isPayment={isPayment}
            createdByName={createdByName}
            tax_exclusive={tax_exclusive}
            {...rest}
          />
        </Fragment>
      )}
    </ModalControl>
  ) : (
    <span> {formatedType} </span>
  )

DetailsModal.propTypes = {
  formatedType: PropTypes.string,
  balance: PropTypes.number,
  arCodeId: PropTypes.number,
  isCharge: PropTypes.bool,
  isPayment: PropTypes.bool,
  createdByName: PropTypes.string,
  tax_exclusive: PropTypes.bool,
}

export default DetailsModal
